<template>
  <v-dialog v-model="show" max-width="400">
    <v-card>
      <v-card-title
        class="body-1"
        style="background-color: black; color: white;"
      >
        {{ $vuetify.lang.t('$vuetify.ADD_SESSION.TITLE') }}
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-col cols="12">
            <!-- <v-select
              v-model="selectedPlace"
              :items="ownedPlaces"
              :item-text="'Name'"
              append-outer-icon="mdi-map-marker"
              return-object
              :menu-props="{ bottom: true, offsetY: true }"
              outlined
              hide-details
              :label="$vuetify.lang.t('$vuetify.DASHBOARD.PLACE')"
              required
              :loading="!ownedPlaces.length && loading.state"
            /> -->
            <v-autocomplete
              v-model="selectedPlace"
              :items="ownedPlaces"
              item-text="Name"
              hide-details
              return-object
              :menu-props="{ bottom: true, offsetY: true }"
              clearable
              outlined
              :label="$vuetify.lang.t('$vuetify.DASHBOARD.PLACE')"
              append-outer-icon="mdi-map-marker"
              :loading="!ownedPlaces.length && loading.state"
            />
          </v-col>
          <v-col cols="11">
            <v-text-field
              v-model="clientId"
              outlined
              label="Client ID"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="21">
            <v-text-field
              v-model="phoneNumber"
              outlined
              label="Phone number"
              hide-details
              append-outer-icon="mdi-phone"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="licencePlate"
              :label="$vuetify.lang.t('$vuetify.CAR_NUMBER')"
              outlined
              append-outer-icon="mdi-car"
              required
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-datetime-picker
              v-model="startTime"
              :label="$vuetify.lang.t('$vuetify.END_TIME')"
              date-format="dd-MM-yyyy"
              :text-field-props="{
                outlined: true,
                appendOuterIcon: 'mdi-calendar'
              }"
            >
              <template v-slot:dateIcon>
                <v-icon>mdi-calendar-outline</v-icon>
              </template>
              <template v-slot:timeIcon>
                <v-icon>mdi-clock-outline</v-icon>
              </template>
            </v-datetime-picker>
            <v-checkbox
              v-model="dontOpenGate"
              label="Don't open gate"
            ></v-checkbox>
          </v-col>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="accent" text @click="show = false">
          {{ $vuetify.lang.t('$vuetify.CANCEL') }}
        </v-btn>
        <v-btn
          color="primary" class="secondary--text"
          :disabled="saveButtonDisabled"
          @click="addSession()"
        >
          {{ $vuetify.lang.t('$vuetify.ADD') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'StartSessionDialog',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      selectedPlace: null,
      licencePlate: '',
      startTime: new Date(),
      clientId: '',
      phoneNumber: '',
      dontOpenGate: true
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('sessions', ['ownedPlaces']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.selectedPlace = null
          this.licencePlate = ''
          this.$emit('close')
        }
      }
    }
  },
  mounted() {
    if (!this.selectedPlace) {
      this.getOwnedPlaces()
    }
  },
  methods: {
    ...mapActions('sessions', ['postSession', 'getOwnedPlaces']),
    addSession() {
      this.postSession({
        AppName: 'ee.barking.app',
        CarNumber: this.licencePlate,
        Client: {
          PhoneNumber: this.phoneNumber
        },
        ClientId: Number(this.clientId),
        IgnoreGates: this.dontOpenGate,
        PlaceId: this.selectedPlace.Id,
        StartTime: this.startTime
      }).then(() => {
        this.$emit('close')
        this.$emit('did-add-session')
      })
    }
  }
}
</script>
